export default __webpack_public_path__ + "static/media/postgresql.b77ab4ac.png";